import './deliveries/reports-late-deliveries/reports-late-deliveries.component';
import './deliveries/reports-late-deliveries/reports-late-deliveries.scss';

import './deliveries/reports-site-created-deliveries/reports-site-created-deliveries.component';
import './deliveries/reports-site-created-deliveries/reports-site-created-deliveries.scss';

import './deliveries/reports-site-deliveries/reports-site-deliveries.component';
import './deliveries/reports-site-deliveries/reports-site-deliveries.scss';

import './effectiveness/reports-activity-drivers/reports-activity-drivers.component';
import './effectiveness/reports-activity-drivers/reports-activity-drivers.scss';

import './effectiveness/reports-activity-shippers/reports-activity-shippers.component';
import './effectiveness/reports-activity-shippers/reports-activity-shippers.scss';

import './effectiveness/reports-activity-vendors/reports-activity-vendors.component';
import './effectiveness/reports-activity-vendors/reports-activity-vendors.scss';

import './effectiveness/reports-service-time-drivers/reports-service-time-drivers.component';
import './effectiveness/reports-service-time-drivers/reports-service-time-drivers.scss';

import './effectiveness/reports-service-time-shippers/reports-service-time-shippers.component';
import './effectiveness/reports-service-time-shippers/reports-service-time-shippers.scss';

import './effectiveness/reports-service-time-vendors/reports-service-time-vendors.component';
import './effectiveness/reports-service-time-vendors/reports-service-time-vendors.scss';

import './panels/reports-all-filters-panel/reports-all-filters-panel.component';
import './panels/reports-all-filters-panel/reports-all-filters-panel.scss';

import './panels/reports-demand-filters-panel/reports-demand-filters-panel.component';
import './panels/reports-demand-filters-panel/reports-demand-filters-panel.scss';

import './panels/reports-supply-filters-panel/reports-supply-filters-panel.component';
import './panels/reports-supply-filters-panel/reports-supply-filters-panel.scss';

import './panels/reports-vendors-filters-panel/reports-vendors-filters-panel.component';
import './panels/reports-vendors-filters-panel/reports-vendors-filters-panel.scss';

import './performance/reports-deliveries-completion-drivers/reports-deliveries-completion-drivers.component';
import './performance/reports-deliveries-completion-drivers/reports-deliveries-completion-drivers.scss';

import './performance/reports-deliveries-completion-shipper/reports-deliveries-completion-shipper.component';
import './performance/reports-deliveries-completion-shipper/reports-deliveries-completion-shipper.scss';

import './performance/reports-deliveries-completion-vendors/reports-deliveries-completion-vendors.component';
import './performance/reports-deliveries-completion-vendors/reports-deliveries-completion-vendors.scss';

import './performance/reports-rush-hours-shipper/reports-rush-hours-shipper.component';
import './performance/reports-rush-hours-shipper/reports-rush-hours-shipper.scss';

import './performance/reports-service-areas/reports-service-areas.component';
import './performance/reports-service-areas/reports-service-areas.scss';

import './performance/reports-tasks-accuracy-drivers/reports-tasks-accuracy-drivers.component';
import './performance/reports-tasks-accuracy-drivers/reports-tasks-accuracy-drivers.scss';

import './performance/reports-tasks-accuracy-shipper/reports-tasks-accuracy-shipper.component';
import './performance/reports-tasks-accuracy-shipper/reports-tasks-accuracy-shipper.scss';

import './performance/reports-tasks-accuracy-vendors/reports-tasks-accuracy-vendors.component';
import './performance/reports-tasks-accuracy-vendors/reports-tasks-accuracy-vendors.scss';

import './reports-sisence-agents-timeline/reports-sisence-agents-timeline.component';
import './reports-sisence-agents-timeline/reports-sisence-agents-timeline.scss';

import './reports-sisense-timeline-view/reports-sisense-timeline-view.component';
import './reports-sisense-timeline-view/reports-sisense-timeline-view.scss';

import './reports-sisense-view/reports-sisense-view.component';
import './reports-sisense-view/reports-sisense-view.scss';

import './reports-view/reports-view.component';
import './reports-view/reports-view.scss';

import './performance/reports-routes-accuracy-drivers/reports-routes-accuracy-drivers.component';
import './performance/reports-routes-accuracy-drivers/reports-routes-accuracy-drivers.scss';
